import * as AttachmentApiUtil from "../../util/attachment_util";

export const RECEIVE_ALL_ATTACHMENTS = "RECEIVE_ALL_ATTACHMENTS"
export const RECEIVE_ATTACHMENT = "RECEIVE_ATTACHMENT"
export const RECEIVE_ATTACHMENT_ERRORS = "RECEIVE_ATTACHMENT_ERRORS"
export const NULL_ERRORS = "NULL_ERRORS"

export const receiveErrors = errors => ({
    type: RECEIVE_ATTACHMENT_ERRORS,
    errors
});

export const nullErrors = () => ({
    type: NULL_ERRORS
})

const receiveAllAttachments = (attachments) => {
    return {
        type: RECEIVE_ALL_ATTACHMENTS,
        attachments
    }
}

const receiveAttachment = (attachment) => {
    return {
        type: RECEIVE_ATTACHMENT,
        attachment
    }
}

export const fetchAllAttachments = (cancelToken) => dispatch => {
    return AttachmentApiUtil.fetchAllAttachments(cancelToken)
        .then(attachments => dispatch(receiveAllAttachments(attachments)))
};

export const uploadFile = (fd,isWipPDF) => dispatch => {
    return AttachmentApiUtil.attachFile(fd,isWipPDF)
        .then(attachment => { 
        dispatch(receiveAttachment(attachment.data)) 
        return attachment.data
        })
};

export const getFile = (file) => dispatch => {
    return AttachmentApiUtil.getFile(file)
        .then(attachment => { 
        dispatch(receiveAttachment(attachment.data)) 
        return attachment.data
        })
};


export const submitFormError = (error) => dispatch => (
    dispatch(receiveErrors(error))
)

export const clearFormErrors = () => dispatch => (
    dispatch(nullErrors())
)

export const softDeleteAttachment = (attachmentId) => dispatch => {
    return AttachmentApiUtil.softDeleteAttachment(attachmentId)
        .then(response => {
            // Optionally, you could dispatch an action to remove from store
            return response.data;
        })
}